import * as angular from "angular";
import {IController, IRootScopeService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PolygonService} from "../../../service-areas/services/polygons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {DepotModel} from "../../../depots/angular/models/depot.model";
import {TravelTimePolygonModel, TravelTimeRuleModel} from "../../models/travel-time-rule.model";
import {AccountsService} from "../../../account/services/accounts-service.service";
import {ServiceAreasService} from "../../../service-areas/services/service-areas-service.service";

export class TravelTimePolygonsViewComponent implements IController {

  travelTimePolygons: TravelTimePolygonModel[];
  serviceAreas?: any[];
  onAddPolygon: Function;
  onUpdatePolygon: Function;
  onRemovePolygon: Function;

  private serviceAreaRef: any;

  private searchQuery: any;
  private selectedServiceArea: any;
  private editingFeature: any;
  private editingFeatureIndex: any;
  private selectedFeature: any;
  private loading: any;
  private mapReady: any;
  private branchIds: any;
  private types: any;

  private depotsRef: any;
  private accountsRef: any;
  public accounts: AccountModel[];
  public depots: DepotModel[];
  public siteDistanceUnit: any;

  public travelTimeFeatureCollection: any;
  public serviceAreasFeatureCollection: any;
  public serviceAreasFeatureCollectionCopy: any;

  /* @ngInject */
  constructor(private $serviceArea, private $log, private polygonService: PolygonService,
              private bringozLoaderService: BringozLoaderService, private $rootScope: IRootScopeService,
              private confirmDialogService: ConfirmDialogService, private accountsService: AccountsService,
              private splitService: SplitService, private $depots, private $accounts, private serviceAreasService: ServiceAreasService) {
    this.serviceAreaRef = this.$serviceArea();
    this.depotsRef = this.$depots();
    this.accountsRef = this.$accounts();
    this.siteDistanceUnit = splitService.getSiteDistanceLargeUnit();
  }

  $onInit() {
    this.searchQuery = undefined;
    this.selectedServiceArea = undefined;
    this.editingFeature = undefined;
    this.selectedFeature = undefined;
    this.loading = false;
    this.mapReady = false;
    this.branchIds = [];
    this.types = [];

    if (this.travelTimePolygons?.length) {
      this.travelTimeFeatureCollection = this.polygonService.getTravelTimeFeatureCollection(this.travelTimePolygons);
    }

    // Service Areas
    if (!!this.serviceAreas?.length) {
      this.serviceAreasFeatureCollection = this.polygonService.getFeatureCollection(this.serviceAreas);
      this.filterServiceAreasFeatureCollection();
    } else {
      this._getAreas()
    }

    this._getAccounts();
    this._getDepots();
  }

  $onChanges(changes) {
    if (changes.travelTimePolygons && !changes.travelTimePolygons.isFirstChange()) {
      this.travelTimeFeatureCollection = this.polygonService.getTravelTimeFeatureCollection(this.travelTimePolygons);
      this.filterServiceAreasFeatureCollection();
      this.onClearEditingFeature();
    }
  };

  onSearchQueryChange(query) {
    this.searchQuery = query;
  }

  onTypesChange(types) {
    this.types = types;
    this._onQueryChange();
  }

  _onQueryChange() {
    // this._getAreas()
  }

  onSelectFeature(feature, doScroll) {
    this.selectedFeature = this.selectedFeature === feature ? undefined : feature;
    if (doScroll) {
      this._anchorScroll(feature.properties.areaId);
    }
  }

  onCreateFeature() {
    this.editingFeature = this.polygonService.getEmptyFeature();
    this.editingFeatureIndex = undefined;
  }

  onChangeCoordinates(coordinates) {
    if (this.editingFeature) {
      this.editingFeature.geometry.coordinates = coordinates ? [coordinates] : undefined;
    }
  }

  onChangeEditingFeature(updatedFeature) {
    this.editingFeature = updatedFeature;
  }

  onCancelCreatingFeature() {
    this.editingFeature = undefined;
  }

  onEditFeature(feature, index) {
    this.editingFeature = angular.copy(feature);
    this.editingFeatureIndex = index;
  }

  onDeleteFeature(feature, event) {
    // const text = 'Are you sure you want to delete this service area?';
    // this.confirmDialogService.confirm('Delete Service Area', text, event)
    //   .then(() => {
    //     this._deleteFeature(feature);
    //   })
    //   .catch((err) => {
    //     this.$log.info('Dialog Closed');
    //   })
  }

  // Map Logic - Reverting back Existing Polygon
  onClearEditingFeature() {
    this.editingFeature = null;
    this.editingFeatureIndex = null;
  }

  // Map Logic - Removing New Polygon
  onCancelEditingFeature() {
    this.editingFeature = undefined;
    this.editingFeatureIndex = undefined;
  }

  onMapReady() {
    this.mapReady = true;
  }

  // ******************************
  //        Private methods
  // ******************************

  _anchorScroll(id) {
    this.$rootScope.$broadcast('anchor-scroll', id);
  }

  private filterServiceAreasFeatureCollection() {
    if (!!this.travelTimePolygons?.length) {
      const travelTimePolygonIds = this.travelTimePolygons.map(item => item.id);
      this.serviceAreasFeatureCollectionCopy = {
        ...this.serviceAreasFeatureCollection,
        features: this.serviceAreasFeatureCollection?.features?.filter((f) => !travelTimePolygonIds.includes(f.properties.id))
      }
    } else {
      this.serviceAreasFeatureCollectionCopy = angular.copy(this.serviceAreasFeatureCollection);
    }
  }

  private _getAreas() {
    const payload = {
      branchIds: this.branchIds,
      serviceTypes: this.types
    }

    this.serviceAreasFeatureCollection = [];
    this.serviceAreasService.getAll(payload)
      .then((serviceAreas) => {
        this.serviceAreasFeatureCollection = this.polygonService.getFeatureCollection(serviceAreas);
      });
    // this.loading = true;
    // this.serviceAreaRef.$getAll(payload)
    //   .then((ids) => {
    //     return this.serviceAreaRef.$asyncValues(ids);
    //   })
    //   .then((serviceAreas) => {
    //     this.serviceAreasFeatureCollection = this.polygonService.getFeatureCollection(serviceAreas);
    //     this.filterServiceAreasFeatureCollection();
    //   })
    //   .catch((error) => {
    //     this.$log.error('Fail to $getAll', error);
    //   })
    //   .finally(() => {
    //     this.loading = false;
    //   })
  }

  private _getAccounts() {
    this.accountsService.getAll({})
      .then(accounts => {
        this.accounts = accounts;
      })

    // this.accountsRef.$getAll()
    //   .then((ids) => {
    //     return this.accountsRef.$asyncValues(ids);
    //   })
    //   .then((accounts) => {
    //     this.accounts = accounts;
    //   })
    //   .catch((error) => {
    //     this.$log.error('Fail to $getAll', error);
    //   });
  }

  private _getDepots() {
    this.depotsRef.$getAll()
      .then((ids) => {
        return this.depotsRef.$asyncValues(ids);
      })
      .then((depots) => {
        this.depots = depots;
      })
      .catch((error) => {
        this.$log.error('Fail to $getAll', error);
      });
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('travelTimePolygonsView', {
    bindings: {
      travelTimePolygons: '<',
      serviceAreas: '<?',
      onAddPolygon: '&',
      onUpdatePolygon: '&',
      onRemovePolygon: '&'
    },
    template: require('./travel-time-polygons-view.html').default,
    controller: TravelTimePolygonsViewComponent
  });
